export default __webpack_public_path__ + "static/media/search.da167052.svg";